import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import AnimatedSection from '../components/AnimatedSection';
import { siteInfo } from '../data/siteInfo';

const Services = () => {
  return (
    <>
      <SEO
        title={`Our Services | ${siteInfo.companyName}`}
        description={`Property investment, buying and selling, lettings, and investor support from ${siteInfo.companyName} in Preston.`}
      />

      <section className="about-page-hero">
        <div className="about-page-hero__bg" aria-hidden="true">
          <img src="https://picsum.photos/seed/services-hero-em/1920/600" alt="" className="about-page-hero__img" />
          <div className="about-page-hero__overlay" />
        </div>
        <div className="container about-page-hero__inner">
          <AnimatedSection variant="fadeUp">
            <p className="about-page-hero__eyebrow">What We Offer</p>
            <h1 className="about-page-hero__title">Our Services</h1>
            <p className="about-page-hero__lead about-page-hero__lead--premium">
              Practical support for buying, selling, letting and building long-term property investments.
            </p>
          </AnimatedSection>
        </div>
      </section>

      <section className="section" style={{ background: '#fff' }}>
        <div className="container">
          <AnimatedSection variant="fadeUp" className="section-intro section-intro--center">
            <p className="eyebrow-label">How We Help</p>
            <h2 className="section-heading gold-underline">Clear Services, Straightforward Advice</h2>
          </AnimatedSection>

          <div className="grid-3 home-services-grid">
            {siteInfo.services.map((service, i) => (
              <AnimatedSection key={service.title} variant="fadeUp" delay={(i % 3) * 0.12}>
                <motion.div
                  className="home-service-card"
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    boxShadow: 'none',
                    padding: '8px 4px 28px',
                    height: '100%',
                    borderBottom: '1px solid rgba(0,0,0,0.06)'
                  }}
                >
                  <h3 className="home-service-card__title">{service.title}</h3>
                  <p className="home-service-card__text">{service.description}</p>
                </motion.div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ background: 'var(--offwhite)' }}>
        <div className="container">
          <AnimatedSection variant="fadeUp" className="section-intro section-intro--center">
            <p className="eyebrow-label">At a Glance</p>
            <h2 className="section-heading gold-underline">Our Focus</h2>
          </AnimatedSection>
          <div
            style={{
              maxWidth: '720px',
              margin: '0 auto',
              display: 'grid',
              gap: '12px'
            }}
          >
            {siteInfo.focusAreas.map((item, i) => (
              <AnimatedSection key={item} variant="fadeUp" delay={i * 0.05}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '14px',
                    padding: '12px 0',
                    borderBottom: '1px solid rgba(0,0,0,0.06)'
                  }}
                >
                  <span
                    aria-hidden="true"
                    style={{
                      width: '8px',
                      height: '8px',
                      marginTop: '8px',
                      flexShrink: 0,
                      background: 'var(--gold)',
                      borderRadius: '50%'
                    }}
                  />
                  <p style={{ margin: 0, color: '#333', lineHeight: 1.6 }}>{item}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta-section">
        <div className="container about-cta-section__inner">
          <AnimatedSection variant="fadeUp">
            <h2 className="about-cta-section__title">Not sure where to start?</h2>
            <p className="about-cta-section__text">
              Tell us what you are looking for — portfolio building, a sale, a letting opportunity, or general advice — and we will help you take the next step.
            </p>
            <div className="about-cta-section__actions">
              <Link to="/contact" className="btn-primary">Contact Us</Link>
              <Link to="/about" className="btn-secondary">About Us</Link>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </>
  );
};

export default Services;
